import React, { useState } from 'react';
import { Card, Form, Button, Alert, ProgressBar } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';

const RejectUpload = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadResult(null);
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file to upload');
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const res = await axios.post(`${base}/api/applicants/reject-upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      setUploadResult(res.data);
      toast.success(`Rejected ${res.data.updated} applicants`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Upload failed');
    } finally {
      setUploading(false);
      setFile(null);
    }
  };

  return (
    <div>
      <h2 className="mb-4">Upload Rejected Applicants</h2>
      <Card className="mb-4">
        <Card.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Excel File</Form.Label>
              <Form.Control type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} disabled={uploading} />
              <Form.Text className="text-muted">
                File should have columns: ats_number (or email), name (optional)
              </Form.Text>
            </Form.Group>
            <Button variant="danger" onClick={handleUpload} disabled={!file || uploading}>
              {uploading ? 'Uploading...' : 'Upload & Mark Rejected'}
            </Button>
          </Form>
          {uploadResult && (
            <Alert variant="info" className="mt-3">
              <div>Updated: {uploadResult.updated}</div>
              <div>Not Found: {uploadResult.notFound}</div>
              {uploadResult.errors?.length > 0 && <div>Errors: {uploadResult.errors.length}</div>}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default RejectUpload;
